/*
 * Kaffa password page (sections/kaffa-password.liquid): the staff "Enter store password" control.
 *
 * The button opens and shuts the store password form under it, and opening moves focus into the field. Escape, in the
 * form or on the button, shuts it and hands focus back to the button. After a wrong password the page arrives with the
 * form open: the section renders it so, and the button's state with it. Without the script, a <noscript> style in the
 * section shows the form and hides the button.
 */
class KaffaPassword extends HTMLElement {
  connectedCallback() {
    this.toggle = this.querySelector('.kaffa-password__toggle');
    this.panel = this.querySelector('.kaffa-password__panel');
    this.staff = this.toggle?.form;
    if (!this.toggle || !this.panel) return;

    this.onToggle = () => this.setOpen(this.panel.hidden);
    this.onKey = (e) => {
      if (e.key !== 'Escape' || this.panel.hidden) return;
      this.setOpen(false);
      this.toggle.focus();
    };
    this.toggle.addEventListener('click', this.onToggle);
    this.staff?.addEventListener('keydown', this.onKey);
  }

  disconnectedCallback() {
    this.toggle?.removeEventListener('click', this.onToggle);
    this.staff?.removeEventListener('keydown', this.onKey);
  }

  setOpen(open) {
    this.panel.hidden = !open;
    this.toggle.setAttribute('aria-expanded', String(open));
    if (open) this.panel.querySelector('input:not([type="hidden"])')?.focus();
  }
}

if (!customElements.get('kaffa-password')) customElements.define('kaffa-password', KaffaPassword);
